<template>
  <div class="table-wrapper">
    <el-table
      :data="tableData"
      border
      style="width: 100%; height: calc(100% - 54px)" 
    >
      <el-table-column
        prop="user"
        align="center"
        label="操作用户"
      />
      <el-table-column
        prop="uri"
        align="center"
        label="路径"
        :show-overflow-tooltip="true"
      />
      <el-table-column
        prop="ip"
        align="center"
        label="登录IP地址"
      />
      <el-table-column
        prop="platform"
        align="center"
        label="登录平台"
      />
      <el-table-column
        prop="menu"
        align="center"
        label="所属模块"
      />
      <el-table-column
        prop="description"
        align="center"
        label="操作描述"
      />
      <el-table-column
        prop="result"
        align="center"
        label="操作结果"
      />
      <el-table-column
        prop="time"
        align="center"
        label="操作时间"
      />
    </el-table>

    <section class="pageination">
      <el-pagination
        @current-change="handlePageChange"
        :current-page="page.pageNumber"
        :page-size="page.pageSize"
        layout="prev, pager, next"
        :total="totalPage"
      />
    </section>
  </div>
</template>

<script>
const MAX_TOTAL = 40000
export default {
  props: {
    tableData: {
      type: Array,
      default: () => [],
    },
    total: {
      type: Number,
      default: 0,
    },
  },
  watch: {
    // 后端限制 最多只能展示200页 4w条数据
    total(val) {
      if (val && val > MAX_TOTAL) {
        this.totalPage = 200
      } else {
        this.totalPage = val
      }
    },
  },
  data() {
    return {
      totalPage: null,
      page: {
        pageSize: 10,
        pageNumber: 1,
      },
    };
  },
  mounted() {},
  methods: {
    handlePageChange(val) {
      this.page.pageNumber = val
      this.$emit('handle-page-change')
    },
  },
};
</script>

<style scoped lang="less"></style>
